import ViewBlock from "../../../../img/butter_svgs/ViewBlock.svg?react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Spinner } from "../../../../components/Spinner/Spinner";
import { Text } from "../../../../components/general/Text";
import React from "react";
import { withIsVisible } from "../../../../utils/reactUtils";
import styled from "@emotion/styled";
import { CHAINS } from "config/chains";

export const ProcessingTransaction: React.FC<{ tx: string; isVisible: boolean }> = withIsVisible(
  ({ tx }) => {
    const network = GlobalStore.useState(s => s.network);
    const theme = GlobalStore.useState(s => s.theme);

    return (
      <Container>
        <DetailsContainer>
          <ViewBlock style={{ color: `${theme.font.primary.default} !important` }} />
          <ViewTransaction
            href={`${CHAINS[network.id].blockExplorerUrl}tx/${tx}`}
            target="_blank"
            rel="noreferrer"
          >
            <Text textStyle={"Paragraph"} size={"Large"} color={theme.font.primary.default}>
              Details
            </Text>
          </ViewTransaction>
        </DetailsContainer>
        <Spinner spinnerSize={16} />
      </Container>
    );
  }
);

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: end;
`;
export const DetailsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
`;

export const ViewTransaction = styled.a`
  display: flex;
  align-items: center;
  gap: 3px;
`;
